import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from "./components/Header";
import About from "./components/About";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import News from "./components/News";
import PageGenerator from './pages/components/PageGenerator';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <>
            <Header />
            <About />
            <Projects />
            <News />
            <Contact />
            <Footer />
          </>
        }
        />
        <Route path="/:language" element={<PageGenerator />} />
      </Routes>
    </Router>
  );
}

export default App;
